const Fields = [
    {
        name: "name",
        label: "Name",
        toolTip: "Credential name",
        type: "text",
        editable: false,
        visible: false,
        validation: [
            { type: "required", errMsg: "Credential name is required" }
        ],
        filterByType: ["aqfer", "aws", "gcp"]
    },
    {
        name: "type",
        label: "Type",
        toolTip: "Credential type",
        type: "select",
        options: [
            { label: "AWS", value: "aws" },
            { label: "GCP", value: "gcp" },
            { label: "AQFER", value: "aqfer" }
        ],
        defaultValue: "aqfer",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Credential type is required" }
        ],
        filterByType: ["aqfer", "aws", "gcp"]
    },
    // Aqfer Credential Fields
    {
        name: "refresh_token",
        label: "Refresh Token",
        toolTip: "Aqfer refresh token",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Refresh token is required" }
        ],
        filterByType: ["aqfer"]
    },
    // AWS Credential Fields
    {
        name: "access_key",
        label: "Access Key",
        toolTip: "AWS access key used for authentication",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Access key is required" }
        ],
        filterByType: ["aws"]
    },
    {
        name: "secret_key",
        label: "Secret Key",
        toolTip: "AWS secret key used for authentication",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Secret key is required" }
        ],
        filterByType: ["aws"]
    },
    {
        name: "session_token",
        label: "Session Token",
        toolTip: "AWS session token for temporary credentials",
        type: "text",
        editable: true,
        visible: false,
        filterByType: ["aws"]
    },
    {
        name: "role_arn",
        label: "Role ARN",
        toolTip: "AWS role ARN for assuming IAM role",
        type: "text",
        editable: true,
        visible: false,
        filterByType: ["aws"]
    },
    {
        name: "external_id",
        label: "External ID",
        toolTip: "External ID for role assumption security",
        type: "text",
        editable: true,
        visible: false,
        filterByType: ["aws"]
    },
    {
        name: "region",
        label: "Region",
        toolTip: "AWS region",
        type: "text",
        editable: true,
        visible: false,
        filterByType: ["aws"]
    },
    // GCP Credential Fields
    {
        name: "project_id",
        label: "Project ID",
        toolTip: "GCP Project ID",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Project ID is required" }
        ],
        filterByType: ["gcp"]
    },
    {
        name: "private_key_id",
        label: "Private Key ID",
        toolTip: "ID associated with the private key",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Private key ID is required" }
        ],
        filterByType: ["gcp"]
    },
    {
        name: "private_key",
        label: "Private Key",
        toolTip: "Private key for authentication",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Private key is required" }
        ],
        filterByType: ["gcp"]
    },
    {
        name: "client_email",
        label: "Client Email",
        toolTip: "Service account email",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Client email is required" }
        ],
        filterByType: ["gcp"]
    },
    {
        name: "client_id",
        label: "Client ID",
        toolTip: "Client ID",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Client ID is required" }
        ],
        filterByType: ["gcp"]
    },
    {
        name: "auth_uri",
        label: "Auth URI",
        toolTip: "Authorization URI",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Auth URI is required" }
        ],
        filterByType: ["gcp"]
    },
    {
        name: "token_uri",
        label: "Token URI",
        toolTip: "Token URI",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Token URI is required" }
        ],
        filterByType: ["gcp"]
    },
    {
        name: "auth_provider_x509_cert_url",
        label: "Auth Provider X509 Cert URL",
        toolTip: "Auth provider certificate URL",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Auth provider certificate URL is required" }
        ],
        filterByType: ["gcp"]
    },
    {
        name: "client_x509_cert_url",
        label: "Client X509 Cert URL",
        toolTip: "Client certificate URL",
        type: "text",
        editable: true,
        visible: false,
        validation: [
            { type: "required", errMsg: "Client certificate URL is required" }
        ],
        filterByType: ["gcp"]
    },
];
 
export default Fields;